module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "carousel",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "carousel-grid",
    attrs: {
      "tabindex": "-1"
    }
  }, _vm._l((_vm.movies), function(movie, key) {
    return _c('movie-list', {
      key: movie.id,
      attrs: {
        "movie": movie,
        "index": key
      }
    })
  }), 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66cfdec2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NewMoviesList.vue
// module id = 87
// module chunks = 0